import { DebugBaseMessage, DebugActionTypes } from '@numeo/types-main-web-app'

export const handleDebugMessage = (message: DebugBaseMessage) => {
    switch (message.data?.action) {
        case DebugActionTypes.Debug_EnableRemoteJS:
            enableRemoteJS(message.data.channelId)
            break
    }
}

const enableRemoteJS = (channelId: string) => {
    const s = document?.createElement('script')
    s.src = 'https://remotejs.com/agent/agent.js'
    s.setAttribute('data-consolejs-channel', channelId)
    document?.head.appendChild(s)
}
